import { computed, toValue } from "vue";
import { useClientComponentTypes } from "./useClientComponentTypes";
import { useDefaultComponentTypes } from "./useDefaultComponentTypes";
export const useComponentType = (componentTypeName) => {
    const { clientComponentTypes } = useClientComponentTypes();
    const { defaultComponentTypes } = useDefaultComponentTypes();
    const componentType = computed(() => {
        const typeName = toValue(componentTypeName);
        if (!typeName) {
            return null;
        }
        const clientComponentType = clientComponentTypes.value.find((type) => type.type === typeName);
        if (clientComponentType) {
            return clientComponentType;
        }
        return (defaultComponentTypes.value.find((type) => type.type === typeName) || null);
    });
    return {
        componentType,
    };
};
